var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { DoorType } from '@shared/types/api/breakInDamage';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import BreakInDamageChoices from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageChoices.vue';
import { DOOR_LEAVES_TYPE_TRAD_KEYS_AND_IMAGES, DOOR_MATERIAL_CHOICES, DOOR_TYPE_TRAD_KEYS_AND_IMAGES, } from '@shared/constants/breakInDamages/DoorConstants';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let DoorDescription = class DoorDescription extends Vue {
    constructor() {
        super(...arguments);
        this.showValidation = false;
        this.DOOR_MATERIAL_CHOICES = DOOR_MATERIAL_CHOICES;
        this.doorTypes = Object.entries(DOOR_TYPE_TRAD_KEYS_AND_IMAGES).map(([doorType, description]) => ({
            value: doorType,
            tradKey: description.tradKey,
            image: description.image,
        }));
        this.doorLeavesTypes = Object.entries(DOOR_LEAVES_TYPE_TRAD_KEYS_AND_IMAGES).map(([leavesType, description]) => description
            ? {
                value: leavesType,
                tradKey: description.tradKey,
                image: description.image,
            }
            : null);
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get displayLeavesAndMaterialQuestions() {
        return (this.breakInDamage.doorType != null &&
            (this.breakInDamage.doorType === DoorType.MainEntrance ||
                this.breakInDamage.doorType === DoorType.Service));
    }
    get isValid() {
        return (this.validation.fieldIsValid('doorType') &&
            this.validation.fieldIsValid('doorLeavesType') &&
            this.validation.fieldIsValid('material'));
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.$emit('goToNextStep');
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
};
__decorate([
    layout.State('color')
], DoorDescription.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], DoorDescription.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], DoorDescription.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], DoorDescription.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], DoorDescription.prototype, "validateBreakInDamage", void 0);
DoorDescription = __decorate([
    Component({
        components: {
            BreakInDamageChoices,
            RadioPrimaryButton,
            BreakInDamageDescriptionSectionCard,
            BreakInDamageDescriptionStep,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
            isSaving: { type: Boolean, default: false },
        },
    })
], DoorDescription);
export default DoorDescription;
